function getMinRating() {
  const selected = document.querySelector(
    '[data-judgeme-rating-facet] input[name="judgeme_rating"]:checked'
  );
  if (!selected) return null;

  const v = selected.value;
  if (v === "" || v == null) return null;

  const min = Number(v);
  return Number.isFinite(min) ? min : null;
}

function applyRatingFilter() {
  const min = getMinRating();

  const ratingNodes = document.querySelectorAll("[data-judgeme-rating]");
  ratingNodes.forEach((node) => {
    // Read rating (robustly)
    const raw = node.getAttribute("data-judgeme-rating");
    let rating = parseFloat(raw);

    if (!Number.isFinite(rating)) rating = 0;

    const show = min === null ? true : rating >= min;

    // Hide the OUTER tile in Dwell (usually <li class="grid__item">)
    const tile =
      node.closest("li.grid__item") ||
      node.closest(".grid__item") ||
      node.closest('[role="listitem"]') ||
      node;

    tile.toggleAttribute("hidden", !show);
  });
}

// ✅ Event delegation (survives Dwell AJAX rerenders)
document.addEventListener("change", (e) => {
  if (e.target.matches('[data-judgeme-rating-facet] input[name="judgeme_rating"]')) {
    applyRatingFilter();
  }
});

document.addEventListener("DOMContentLoaded", applyRatingFilter);
